import {
  IonButton,
  IonCheckbox,
  IonContent,
  IonImg,
  IonInput,
  IonItem,
  IonLabel,
  IonPage,
  IonRadio,
  IonRadioGroup,
  IonSelect,
  IonSelectOption,
  IonTabBar,
  IonTabButton,
  IonText,
  useIonModal
} from "@ionic/react";
import Header from "../components/Header";
import { useRouteMatch } from "react-router";
import { useUsersStore } from "../stores/users.store";
import { useEffect, useState } from "react";
import payfastLogo from "../assets/graphics/payfast-logo.png";
import bitpayLogo from "../assets/graphics/bitpay-logo.png";
import TermsAndConditions from "./Terms";
import QRCodeComponent from "../components/QRCode";
import toast from "react-hot-toast";
import { createOrder, getUser } from "../lib/firebase";
import { functionsURL, payfast } from "../configs/authConfig";
import { isNativeIos } from "../components/ProfileCard";

interface Order {
  new: boolean;
  user: string;
  type: string;
  quantity: number;
  allocated: boolean;
  timestamp: number;
  fees?: number;
  price?: number;
}

const QuoCoin: React.FC = () => {
  // get mode from path /quoCoin/:mode
  const mode = useRouteMatch<{ mode: string }>().params.mode;
  const [activeTab, setActiveTab] = useState<string>(mode);
  const [recipient, setRecipient] = useState<string>("");
  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(false);
  const [paymentMethod, setPaymentMethod] = useState<string>("payfast"); // ["payfast", "paygate", "bitpay"]
  const [presentTermsModal, dismissTermsModal] = useIonModal(
    TermsAndConditions,
    {
      dismiss: () => dismissTermsModal()
    }
  );
  const [quoCoin, userId] = useUsersStore(state => [
    state.user?.quoCoin ?? 0,
    state.user?.userId ?? "-1"
  ]);
  const [amount, setAmount] = useState<number>(
    mode === "buy" ? 200 : quoCoin > 50 ? 50 : Math.floor(quoCoin)
  );

  const [isNative, setIsNative] = useState(false);
  useEffect(() => {
    const isIOS = isNativeIos();
    setIsNative(isIOS);
    if (activeTab === "buy" && isIOS) {
      setActiveTab("send");
    }
    // eslint-disable-next-line
  }, []);

  const handleBuy = async () => {
    console.log("buying");
    const order: Order = {
      new: true,
      user: userId,
      type: "buy",
      quantity: amount,
      allocated: false,
      timestamp: new Date().getTime()
    };

    order.fees = 0.06 * amount;
    order.price = amount + (order.fees || 0);

    const response = await createOrder(order);

    window.location.href =
      `${payfast.url}?cmd=_paynow` +
      "&item_name=QuoCoin&item_description=ExchangeToken&amount=" +
      order.price +
      `&receiver=${payfast.merchantId}` +
      `&return_url=${functionsURL}/successfulPaymentV2?orderId=` +
      response.key +
      `&cancel_url=https://qp-app.web.app/quoCoin`;
  };

  const handleSend = async () => {
    // TODO: ADD CONFIRM PAGE
    if (recipient === userId) {
      toast.error("You cannot send QUO Coin to yourself!", {
        duration: 3000
      });
      setRecipient("");
      return;
    }
    console.log(`Send ${amount} QUO to ${recipient}`);
    const user = await getUser(recipient);
    if (!user) {
      toast.error("User not found!", {
        duration: 3000
      });
      setRecipient("");
      return;
    }
    const order: any = {
      new: true,
      user: userId,
      type: "send-quo",
      quantity: amount,
      allocated: false,
      timestamp: new Date().getTime(),
      recipientName: `${user.firstName} ${user.lastName}`,
      recipient
    };
    const response = await createOrder(order);
    if (response.key) {
      toast.success("QUO coin sent successfully!", {
        duration: 3000
      });
      setRecipient("");
      setAmount(0);
    } else {
      toast.error("Something went wrong!", {
        duration: 3000
      });
    }
  };

  return (
    <IonPage>
      <Header title="QUO Coin" back />
      <IonContent fullscreen scrollY={false}>
        <div className="bg-primary-90 h-full text-white">
          <div className="flex flex-col justify-center items-center">
            <div className="font-semibold text-sm">Current Wallet Balance</div>
            <div className="text-3xl text-green-400 py-2">
              QUO {quoCoin?.toFixed(2)}
            </div>
          </div>
          <IonTabBar
            onIonTabsDidChange={e => {
              setActiveTab(e.detail.tab);
            }}
            className="m-2 bg-black rounded-lg px-2"
          >
            {!isNative && (
              <IonTabButton
                tab="buy"
                className={`text-base rounded-lg " ${
                  activeTab === "buy" ? "bg-primary-50 text-white" : "bg-black"
                }`}
              >
                <IonLabel>Buy</IonLabel>
              </IonTabButton>
            )}
            <IonTabButton
              tab="send"
              className={`text-base rounded-lg " ${
                activeTab === "send" ? "bg-primary-50 text-white" : "bg-black"
              }`}
            >
              <IonLabel>Send</IonLabel>
            </IonTabButton>

            <IonTabButton
              tab="receive"
              className={`text-base rounded-lg " ${
                activeTab === "receive"
                  ? "bg-primary-50 text-white"
                  : "bg-black"
              }`}
            >
              <div className="flex justify-center items-center">
                <IonLabel>Receive</IonLabel>
              </div>
            </IonTabButton>
          </IonTabBar>
          {activeTab === "buy" && (
            <>
              <div className="flex flex-row px-4 justify-between pt-4">
                <div>
                  <IonLabel>Currency</IonLabel>
                  <IonSelect
                    disabled
                    className="border border-primary-50 rounded-lg w-32"
                    value="quo"
                  >
                    <IonSelectOption value="quo">QUO</IonSelectOption>
                  </IonSelect>
                </div>
                <div className="flex flex-col grow pl-8">
                  <IonLabel>Amount</IonLabel>
                  <div className="flex flex-row border border-primary-50 rounded-lg w-fit items-center pl-2 pr-4">
                    <IonInput
                      min={50}
                      type="number"
                      onIonChange={e => setAmount(Number(e.detail.value))}
                      value={amount}
                    />
                    <IonLabel>QUO</IonLabel>
                  </div>
                </div>
              </div>
              <div className="flex justify-between pt-4 px-4">
                <span>Amount</span>
                <span>{amount} QUO COIN</span>
              </div>
              <div className="flex justify-between px-4">
                <span>Rate</span>
                <span>1 QUO = ZAR 1</span>
              </div>
              <div className="flex justify-between pt-4 px-4">
                <span>Deposit fee</span>
                <span>6%</span>
              </div>
              <div className="flex justify-between px-4">
                <span>Total Payment</span>
                <span>R {(amount * 1.06).toFixed(2)}</span>
              </div>
              <div className="flex flex-col pt-4 px-4">
                <span>Payment Method</span>
                <IonRadioGroup
                  value={paymentMethod}
                  onIonChange={(e: any) => setPaymentMethod(e.detail.value)}
                >
                  <IonItem
                    className="border border-primary-50 rounded-lg mt-2"
                    detail={false}
                    button
                    onClick={() => {
                      setPaymentMethod("payfast");
                    }}
                  >
                    <IonImg className="w-8 h-8" src={payfastLogo} />
                    <span className="pl-2">Payfast</span>
                    <IonRadio
                      mode="md"
                      slot="end"
                      className="float-right"
                      value="payfast"
                    />
                  </IonItem>
                  <IonItem
                    disabled
                    className="border border-primary-50 rounded-lg mt-2"
                    detail={false}
                    button
                    onClick={() => {
                      setPaymentMethod("bitpay");
                    }}
                  >
                    <IonImg className="w-8 h-8" src={bitpayLogo} />
                    <span className="pl-2">BitPay</span>
                    <IonRadio
                      mode="md"
                      slot="end"
                      className="float-right"
                      value="bitpay"
                    />
                  </IonItem>
                </IonRadioGroup>
              </div>
              <div className="p-4 flex justify-center items-center">
                <IonCheckbox
                  checked={acceptedTerms}
                  onIonChange={e => setAcceptedTerms(e.detail.checked)}
                />
                <span className="pl-2">
                  I agree with QuidPro's{" "}
                  <IonText
                    color="dark"
                    className="underline text-sm font-bold cursor-pointer"
                    onClick={e => presentTermsModal()}
                  >
                    {"Terms of Service"}
                  </IonText>
                  .
                </span>
              </div>
              <div className="fixed bottom-0 w-screen p-2">
                <IonButton
                  disabled={!acceptedTerms}
                  color="primary"
                  className="rounded-lg w-full"
                  onClick={handleBuy}
                >
                  Buy
                </IonButton>
              </div>
            </>
          )}
          {activeTab === "receive" && (
            <div className="flex flex-col items-center justify-center">
              <div className="text-lg font-semibold p-4 ion-text-center">
                Share your wallet information with others to receive QUO Coin
              </div>
              <QRCodeComponent qrCode={userId || ""} />
            </div>
          )}
          {activeTab === "send" && (
            <div className="flex flex-col items-center justify-center">
              <div className="flex flex-row px-4 justify-between pt-4">
                <div>
                  <IonLabel>Currency</IonLabel>
                  <IonSelect
                    disabled
                    className="border border-primary-50 rounded-lg w-32"
                    value="quo"
                  >
                    <IonSelectOption value="quo">QUO</IonSelectOption>
                  </IonSelect>
                </div>
                <div className="flex flex-col grow pl-8">
                  <IonLabel>Amount</IonLabel>
                  <div className="flex flex-row border border-primary-50 rounded-lg w-fit items-center pl-2 pr-4">
                    <IonInput
                      min={10}
                      max={quoCoin}
                      type="number"
                      onIonChange={e => setAmount(Number(e.detail.value))}
                      value={amount}
                    />
                    <IonLabel>QUO</IonLabel>
                  </div>
                </div>
              </div>
              <div className="p-4 w-full">
                <IonLabel>Recipient</IonLabel>
                <div className="flex flex-row border border-primary-50 rounded-lg items-center pl-2 pr-4">
                  <IonInput
                    placeholder="Enter recipient's wallet ID"
                    maxlength={28}
                    onIonChange={e => setRecipient(e.detail.value || "")}
                    value={recipient}
                  />
                  {/* TODO: ADD QR-CODE SCANNER */}
                </div>
              </div>
              <div className="p-4 flex justify-center items-center">
                <IonCheckbox
                  checked={acceptedTerms}
                  onIonChange={e => setAcceptedTerms(e.detail.checked)}
                />
                <span className="pl-2">
                  I agree with QuidPro's{" "}
                  <IonText
                    color="dark"
                    className="underline text-sm font-bold cursor-pointer"
                    onClick={e => presentTermsModal()}
                  >
                    {"Terms of Service"}
                  </IonText>
                  .
                </span>
              </div>
              <div className="fixed bottom-0 w-screen p-2">
                <IonButton
                  disabled={
                    !acceptedTerms || !recipient || recipient?.length !== 28
                  }
                  color="primary"
                  className="rounded-lg w-full"
                  onClick={handleSend}
                >
                  Send
                </IonButton>
              </div>
            </div>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default QuoCoin;
